import { toast, ToastContainer } from "react-toastify";
import { useContext, useEffect, useState } from "react";
import {
  FiCheckCircle, FiXCircle, FiFileText, FiX, FiEye, FiShield,
  FiChevronLeft, FiChevronRight,
} from "react-icons/fi";
import axios from "axios";
import AdminMasterLayout from "../../../layouts/admin/AdminMasterLayout";
import AppContext from "../../../contexts/AppContext";
import "../../../assets/css/admin/screens/shop/AdminShopManagement.css";
import "react-toastify/dist/ReactToastify.css";

const ShopsManagement = () => {
  const { baseUrl, baseUrlForFiles, adminAuthToken } = useContext(AppContext);
  const [stats, setStats] = useState(null);
  const [shops, setShops] = useState([]);
  const [kycModal, setKycModal] = useState({ open: false, shop: null });


    // Pagination
const [currentPage, setCurrentPage] = useState(1);
const [totalPages, setTotalPages] = useState(1);
const [totalItems, setTotalItems] = useState(0);
const itemsPerPage = 10;

const viewAllShops = () => {
  axios
    .get(`${baseUrl}/admin/shop/viewAllShops`, {
      params: {
        page: currentPage,
        per_page: itemsPerPage,
      },
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${adminAuthToken}`,
      },
    })
    .then((response) => {
      setShops(response.data.shops);
      setTotalPages(response.data.last_page);
      setTotalItems(response.data.total);
    })
    .catch((error) => {
      console.error(error);
    });
};

  const handleApprove = (id) => {
    const formdata = new FormData();
    formdata.append("shop_id", id);
    axios.post(`${baseUrl}/admin/shop/approveShop`, formdata,{
      headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${adminAuthToken}`,
          },
    })
      .then(() => { toast.success("Shop Approved"); viewAllShops(); viewShopStats(); })
      .catch((error) => { toast.error("Something went wrong"); console.log(error); });
  };

  const handleReject = (id) => {
    const formdata = new FormData();
    formdata.append("shop_id", id);
    axios.post(`${baseUrl}/admin/shop/rejectShop`, formdata,{
      headers: {
            "Content-Type": "multipart/form-data",
            Authorization: `Bearer ${adminAuthToken}`,
          },
    })
      .then(() => { toast.warning("Shop Rejected"); viewAllShops(); viewShopStats(); })
      .catch((error) => { toast.error("Something went wrong"); console.log(error); });
  };

  const viewShopStats = () => {
    axios.get(`${baseUrl}/admin/shop/stats` ,{
      headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${adminAuthToken}`,
          },
    })
      .then((response) => { setStats(response.data); })
      .catch((error) => { console.log(error); });
  };

  // currentPage jab bhi change ho, backend se woh page mangwao
  useEffect(() => { viewAllShops(); }, [currentPage]);

  useEffect(() => { viewShopStats(); }, []);

  const openKyc = (shop) => setKycModal({ open: true, shop });
  const closeKyc = () => setKycModal({ open: false, shop: null });

  const getStatusClass = (status) => {
    if (status === "Approved") return "sm-status sm-status-approved";
    if (status === "Pending")  return "sm-status sm-status-pending";
    return "sm-status sm-status-banned";
  };

  // Max 5 page-number buttons visible
  const getVisiblePageNumbers = () => {
    const maxVisible = 5;
    let startPage = Math.max(1, currentPage - Math.floor(maxVisible / 2));
    let endPage = Math.min(totalPages, startPage + maxVisible - 1);
    if (endPage - startPage + 1 < maxVisible) {
      startPage = Math.max(1, endPage - maxVisible + 1);
    }
    const pages = [];
    for (let page = startPage; page <= endPage; page++) pages.push(page);
    return pages;
  };

  return (
    <AdminMasterLayout>
      <ToastContainer position="top-right" autoClose={3000} />

      <div className="sm-shell">
        <main className="sm-main">
          <section className="sm-card-shell">
            <h3 className="sm-page-title">Shop / Seller Management</h3>

            {/* Summary Cards */}
            <div className="sm-summary-grid">
              <div className="sm-summary-card">
                <div>
                  <span className="sm-card-label">Total Shops</span>
                  <h3 className="sm-card-value">{stats?.total_shops ?? "0"}</h3>
                  <p className="sm-card-sub">All registered</p>
                </div>
                <div className="sm-card-icon"><FiShield size={22} /></div>
              </div>
              <div className="sm-summary-card">
                <div>
                  <span className="sm-card-label">Pending Approval</span>
                  <h3 className="sm-card-value">{stats?.pending_shops ?? "0"}</h3>
                  <p className="sm-card-sub">Waiting for review</p>
                </div>
                <div className="sm-card-icon"><FiCheckCircle size={22} /></div>
              </div>
              <div className="sm-summary-card">
                <div>
                  <span className="sm-card-label">Rejected Shops</span>
                  <h3 className="sm-card-value">{stats?.Rejected_shops ?? "0"}</h3>
                  <p className="sm-card-sub">Policy violations</p>
                </div>
                <div className="sm-card-icon sm-card-icon-alert"><FiXCircle size={22} /></div>
              </div>
            </div>

            {/* Table */}
            <div className="sm-table-container">
              <table className="sm-table">
                <thead>
                  <tr>
                    <th>ID</th><th>Shop</th><th>Description</th><th>Phone</th>
                    <th>Business Email</th><th>Business Address</th><th>City</th>
                    <th>Status</th><th>KYC Document</th><th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  {shops.map((s) => (
                    <tr key={s.id}>
                      <td>{s.id}</td>
                      <td>
                        <div className="sm-shop-cell">
                          {s.shop_image ? (
                            <img src={`${baseUrlForFiles}/${s.shop_image}`} alt={s.store_name} className="sm-shop-avatar-img" />
                          ) : (
                            <div className="sm-shop-avatar">{s.store_name?.charAt(0)?.toUpperCase() || "S"}</div>
                          )}
                          <span className="sm-shop-name">{s.store_name}</span>
                        </div>
                      </td>
                      <td className="sm-td-truncate">{s.description || "—"}</td>
                      <td>{s.phone || "—"}</td>
                      <td>{s.business_email || "—"}</td>
                      <td>{s.business_address || "—"}</td>
                      <td>{s.city || "—"}</td>
                      <td><span className={getStatusClass(s.status)}>{s.status || "Pending"}</span></td>
                      <td><span className="sm-doc-tag">{s.kyc_document ? "Uploaded" : "—"}</span></td>
                      <td>
                        <div className="sm-actions">
                          <button className="sm-btn sm-btn-approve" onClick={() => handleApprove(s.id)}><FiCheckCircle /></button>
                          <button className="sm-btn sm-btn-reject"  onClick={() => handleReject(s.id)}><FiXCircle /></button>
                          <button className="sm-btn sm-btn-kyc"     onClick={() => openKyc(s)}><FiFileText /></button>
                        </div>
                      </td>
                    </tr>
                  ))}
                  {shops.length === 0 && (
                    <tr><td colSpan="10" className="sm-empty">No shops found</td></tr>
                  )}
                </tbody>
              </table>

              {/* Pagination controls */}
              {shops.length > 0 && totalPages > 1 && (
                <div className="sm-pagination-bar">
                  <span className="sm-pagination-info">
                    Showing {(currentPage - 1) * itemsPerPage + 1}-
                    {Math.min(currentPage * itemsPerPage, totalItems)} of {totalItems}
                  </span>
                  <div className="sm-pagination-controls">
                    <button
                      className="sm-page-btn sm-page-btn--nav"
                      disabled={currentPage === 1}
                      onClick={() => setCurrentPage(currentPage - 1)}
                    >
                      <FiChevronLeft size={14} />
                    </button>
                    {getVisiblePageNumbers().map((page) => (
                      <button
                        key={page}
                        className={`sm-page-btn ${page === currentPage ? "sm-page-btn--active" : ""}`}
                        onClick={() => setCurrentPage(page)}
                      >
                        {page}
                      </button>
                    ))}
                    <button
                      className="sm-page-btn sm-page-btn--nav"
                      disabled={currentPage === totalPages}
                      onClick={() => setCurrentPage(currentPage + 1)}
                    >
                      <FiChevronRight size={14} />
                    </button>
                  </div>
                </div>
              )}
            </div>
          </section>
        </main>
      </div>

      {/* KYC Modal */}
      {kycModal.open && kycModal.shop && (
        <div className="kyc-overlay" onClick={closeKyc}>
          <div className="kyc-modal" onClick={(e) => e.stopPropagation()}>
            <div className="kyc-header">
              <div className="kyc-header-title"><FiFileText className="kyc-header-icon" /> KYC Documents</div>
              <button className="kyc-close-btn" onClick={closeKyc}><FiX /></button>
            </div>
            <div className="kyc-shop-info">
              <div className="kyc-shop-avatar">{kycModal.shop.store_name?.charAt(0)?.toUpperCase() || "S"}</div>
              <div>
                <p className="kyc-shop-name">{kycModal.shop.store_name}</p>
                <p className="kyc-shop-email">{kycModal.shop.email}</p>
              </div>
              <span className={`${getStatusClass(kycModal.shop.status)} kyc-shop-status`}>{kycModal.shop.status || "Pending"}</span>
            </div>
            <div className="kyc-doc-single">
              <div className="kyc-doc-label"><FiEye size={12} /> KYC Document (PDF)</div>
              {kycModal.shop.kyc_document ? (
                <div className="kyc-pdf-wrapper">
                  <a href={`${baseUrlForFiles}/${kycModal.shop.kyc_document}`} target="_blank" rel="noopener noreferrer" className="kyc-pdf-link">
                    <FiFileText size={13} /> Open KYC Document
                  </a>
                </div>
              ) : (
                <div className="kyc-doc-empty">No Document Uploaded</div>
              )}
            </div>
            <div className="kyc-footer">
              <button className="kyc-btn-close" onClick={closeKyc}>Close</button>
              <button className="kyc-btn-approve" onClick={() => { handleApprove(kycModal.shop.id); closeKyc(); }}>
                <FiCheckCircle size={13} /> Approve Shop
              </button>
              <button className="kyc-btn-reject" onClick={() => { handleReject(kycModal.shop.id); closeKyc(); }}>
                <FiXCircle size={13} /> Reject Shop
              </button>
            </div>
          </div>
        </div>
      )}
    </AdminMasterLayout>
  );
};

export default ShopsManagement;